module.exports = __webpack_public_path__ + "img/1 (10).e4d944f2.png";